import { QueryHookOptions, useQuery } from 'react-apollo';

import {
  MessagesMessageThreadMessagesErrorFragment,
  MessagesMessageThreadsQuery,
  MessageThreadsErrorFragment,
  MessageThreadsSuccessFragment,
} from 'Src/generated/graphql';

import { GET_MESSAGE_THREADS_QUERY } from '../queries/messageThreads';

function isError(
  messageThreads:
    | MessageThreadsSuccessFragment
    | MessageThreadsErrorFragment
    | undefined
    | null,
): messageThreads is MessagesMessageThreadMessagesErrorFragment {
  return (
    Boolean(messageThreads) &&
    (messageThreads as MessageThreadsErrorFragment).__typename ===
      'GenericError'
  );
}

export default function useMessageThreads(options: QueryHookOptions = {}) {
  const result = useQuery<MessagesMessageThreadsQuery>(
    GET_MESSAGE_THREADS_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      ...options,
    },
  );

  const messageThreads = result.data?.messageThreads;

  if (result.error) {
    return {
      ...result,
      data: undefined,
      error: result.error,
    };
  }

  if (isError(messageThreads)) {
    return {
      ...result,
      data: undefined,
      error: messageThreads,
    };
  }

  return {
    ...result,
    data: {
      messageThreads:
        messageThreads ||
        ({
          nodes: [],
          pagination: { currentPage: 0, perPage: 0, total: 0, totalPages: 0 },
        } as MessageThreadsSuccessFragment),
    },
    error: undefined,
  };
}
